import { useOpstelClient } from "@opstel/contexts/opstelClient/useOpstelClient";
import { instances } from "@opstel/query/queryKeys/instanceKeys";
import { actionSchema } from "@opstel/query/v2/actionParser";
import { Action } from "@opstel/query/v2/models/action";
import { useCurrentInstanceId } from "@shared/common/contexts/instanceMetadata/useInstanceId";
import { useQuery } from "@tanstack/react-query";

export function useShuntingUnitActions(shuntingUnitId: string) {
  const { instanceId } = useCurrentInstanceId();
  const { opstelClient } = useOpstelClient();

  return useQuery({
    queryKey: instances.current(instanceId).shuntingUnit(shuntingUnitId).actions,
    queryFn: () =>
      opstelClient.getActionsForShuntingUnit({
        instanceId: instanceId ?? "",
        shuntingUnitId,
      }),
    select: (actions) => actions.map((a) => actionSchema.parse(a) as Action),
  });
}
